import { styled } from '@mui/system'
import { forwardRef, MouseEventHandler } from 'react'
import { Icon } from '../../core'
import { Severities, Variants } from '../../core/Alert'
import { IconButton } from '../../core/IconButton'
import { useTheme } from '../../theme'
import { getAlertIconAndButtonColors } from '../../utils/commonFunctions'

const StyledIconButton = styled(IconButton)({
  backgroundColor: 'transparent !important',
  boxShadow: 'none !important',
})

interface AlertCloseButtonProps {
  severity: Severities
  variant: Variants
  onClickCloseIcon: MouseEventHandler
}

export const AlertCloseButton = forwardRef<SVGSVGElement, AlertCloseButtonProps>((props, ref) => {
  void ref
  const { onClickCloseIcon, variant, severity } = props
  const theme = useTheme()

  return (
    <StyledIconButton size={'xXSmall'} onClick={onClickCloseIcon}>
      <Icon icon={'close_small'} color={getAlertIconAndButtonColors(theme, variant, severity)} />
    </StyledIconButton>
  )
})
